import React, { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, Image } from 'lib/components';
import JobRow from './JobRow';
import { useWindowResize } from 'hooks/useWindowResize';
import { useSelectAuthorization } from 'store';
import { Job } from 'types';
import { HeaderItem, Sort, SortField } from './types';
import classes from './index.module.scss';

interface Props {
	jobs: Job[];
	sortField: SortField;
	onSortFieldChange: (sortField: SortField) => void;
}

const HEADER_ITEMS: HeaderItem[] = [
	{ label: 'Job ID', sort: 'asc', field: 'jobId' },
	{ label: 'Current Status', sort: 'asc', field: 'status' },
	{ label: 'Room No.', sort: 'asc', field: 'roomNo' },
	{ label: 'Ordering Physician' },
	{ label: 'Patient Name' },
	{ label: 'Assigned Nurse' },
	{ label: 'Start Time', sort: 'asc', field: 'startTime' },
	{ label: 'Chat' },
];

const HospitalJobsDataTable = ({ jobs, sortField, onSortFieldChange }: Props) => {
	const { push } = useHistory();
	const { canReadJob } = useSelectAuthorization();
	const [sortFields] = useState(
		HEADER_ITEMS.filter((item) => item.field && item.sort).reduce<Record<string, Sort>>((acc, cur) => {
			if (cur.field && cur.sort) {
				acc[cur.field] = cur!.sort;
			}
			return acc;
		}, {})
	);

	const { isSmallerDevice } = useWindowResize();

	const handleHeaderItemClick = useCallback(
		(headerItem: HeaderItem) => {
			if (headerItem.field && sortFields[headerItem.field]) {
				if (headerItem.field === sortField?.field) {
					onSortFieldChange({
						field: headerItem.field,
						sort: sortField?.sort === 'asc' ? 'desc' : 'asc',
					});
				} else if (sortField?.field !== headerItem.field) {
					onSortFieldChange({ field: headerItem.field, sort: 'desc' });
				}
			}
		},
		[sortField, sortFields, onSortFieldChange]
	);

	const toViewJob = useCallback((job: Job, openChat: boolean = false) => {
		if (canReadJob) push(`/jobs/view/${job.id}${openChat ? '?chat=open' : ''}`);
	}, []);

	const renderHeaderItem = (headerItem: HeaderItem) => {
		if (!headerItem.field || !headerItem.sort) {
			return (
				<div key={Math.random()} className={classes['col']}>
					<Typography weight="light" variant={isSmallerDevice ? 'h5' : 'h6'}>
						{headerItem.label}
					</Typography>
				</div>
			);
		} else {
			return (
				<div
					onClick={() => handleHeaderItemClick(headerItem)}
					key={Math.random()}
					className={classes['col']}
					style={{
						cursor: 'pointer',
					}}
				>
					<Typography weight="light" variant={isSmallerDevice ? 'h5' : 'h6'}>
						{headerItem.label}
					</Typography>
					<Image
						src={'icTableDown'}
						style={{
							marginLeft: '6px',
							transform:
								sortField?.field === headerItem.field && sortField.sort === 'desc'
									? 'rotate(180deg)'
									: 'initial',
						}}
					/>
				</div>
			);
		}
	};
	return (
		<div className={classes['inventories-datatable']}>
			<div className={classes['table-wrapper']}>
				<div className={classes['table-container']}>
					<div className={classes['toolbar']}>{HEADER_ITEMS.map((item) => renderHeaderItem(item))}</div>
					<div className={classes['container']}>
						{jobs?.map((job) => (
							<JobRow key={job.id} job={job} toViewJob={toViewJob} />
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default HospitalJobsDataTable;
